export const initRemoveColumn = (column) => {
    column.getElement().querySelectorAll('[data-remove-column]').forEach((element) => {
        element.addEventListener('click', e => {
            e.preventDefault();
            column.remove();
        });
    });
};
